import request from '@/utils/request'

export function getNoticeMsgType() {
  return request({
    url: 'api/v1/notice-msg/getNoticeType',
    method: 'get'
  })
}

export function getNoticeMsg(data) {
  return request({
    url: 'api/v1/notice-msg/getNoticeMsg',
    method: 'post',
    data: data
  })
}

export function updateNoticeMsg(data) {
  return request({
    url: 'api/v1/notice-msg/updateNoticeMsg',
    method: 'post',
    data: data
  })
}

export function delNoticeMsg(data) {
  return request({
    url: 'api/v1/notice-msg/delNoticeMsg',
    method: 'delete',
    data: data
  })
}

export function importNoticeMsg(data) {
  return request({
    url: 'api/v1/notice-msg/importNoticeMsg',
    method: 'post',
    data: data
  })
}

export function exportNoticeMsg(data) {
  return request({
    url: 'api/v1/notice-msg/exportNoticeMsg',
    method: 'post',
    data: data
  })
}
